import React, { lazy } from 'react';
import { BookOpen } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PriceDisplay } from './PriceDisplay';
export function ProductReveal() {
  return <section className="py-12 md:py-20 px-4 bg-white" data-id="element-175">
      <div className="max-w-4xl mx-auto text-center" data-id="element-176">
        <p className="text-spice-600 font-bold tracking-widest uppercase mb-4" data-id="element-177">
          Presentamos...
        </p>

        <div className="relative inline-block mb-3 md:mb-6" data-id="element-178">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-spice-700 via-spice-500 to-spice-700 leading-tight pb-2" data-id="element-179">
            La Biblia de los Condimentos Caseros
          </h2>
          <div className="absolute -inset-2 bg-spice-200/30 rounded-2xl -z-10 blur-md" data-id="element-180"></div>
        </div>

        <p className="text-xl md:text-2xl text-gray-600 mb-8 md:mb-12 italic font-heading" data-id="element-181">
          "El Sistema Completo para Vender Condimentos Artesanales desde Tu
          Cocina"
        </p>

        <div className="relative max-w-lg mx-auto mb-8 md:mb-12" data-id="element-182">
          <div className="aspect-[4/3] md:aspect-square rounded-3xl shadow-xl border border-spice-200 overflow-hidden" data-id="element-183">
            <img src="https://cdn.magicpatterns.com/uploads/d68pLyDmZyqmiQq3zzX4aD/hf_20260302_211124_fb28b994-a5af-4288-8127-2b2768189870.jpg" alt="La Biblia de los Condimentos Caseros" loading="lazy" className="w-full h-full object-cover" data-id="element-184" />
          </div>
        </div>

        <p className="text-lg md:text-xl text-gray-800 max-w-2xl mx-auto mb-8 md:mb-12 leading-relaxed" data-id="element-185">
          Dominá el arte de los condimentos caseros y{' '}
          <strong className="text-gray-900" data-id="element-186">hacé tus primeras ventas</strong>...
          incluso si nunca vendiste nada en tu vida y nunca estudiaste
          gastronomía.
        </p>

        <div className="bg-spice-50 border-2 border-spice-200 rounded-2xl md:rounded-3xl p-5 md:p-8 max-w-2xl mx-auto shadow-lg relative" data-id="element-187">
          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-urgency-600 text-white px-6 py-2 rounded-full font-bold shadow-md whitespace-nowrap" data-id="element-188">
            OFERTA SOLO POR HOY !!!
          </div>

          <div className="mb-6 pt-4" data-id="element-189">
            <p className="text-gray-500 font-medium mb-2" data-id="element-190">PRECIO REGULAR:</p>
            <p className="text-2xl text-gray-400 line-through decoration-urgency-500 decoration-2" data-id="element-191">
              <PriceDisplay amountArs={97000} data-id="element-192" />
            </p>
          </div>

          <div className="mb-5 md:mb-8" data-id="element-193">
            <p className="text-spice-700 font-bold mb-2" data-id="element-194">PRECIO DE OFERTA:</p>
            <div className="relative inline-block" data-id="element-195">
              <p className="text-5xl md:text-7xl font-black text-spice-600 animate-pulse-glow" data-id="element-196">
                <PriceDisplay amountArs={14997} data-id="element-197" />
              </p>
              <div className="absolute -inset-3 bg-spice-300/20 rounded-2xl -z-10 blur-lg" data-id="element-198"></div>
            </div>
          </div>

          <div className="mb-5 md:mb-8 flex flex-col items-center gap-1" data-id="element-199">
            <p className="text-xs md:text-base font-medium text-gray-500 tracking-wide whitespace-nowrap" data-id="element-200">
              Pago único · Sin suscripciones · Sin cargos ocultos
            </p>
          </div>

          <div className="mb-4" data-id="element-201">
            <CtaButton text="QUIERO LA BIBLIA DE LOS CONDIMENTOS" className="w-full" data-id="element-202" />
          </div>

          <p className="text-sm text-gray-500" data-id="element-203">
            Descarga inmediata de todo el paquete
          </p>
        </div>
      </div>
    </section>;
}